import HotelHeadline from './HotelHeadline.component';
export default HotelHeadline;